import { Roles } from '../../../constants';

import type { ISelectOption } from '../../../utils/types';

export const PROVIDER_SSN_ALLOWED_ROLES = [Roles.Admin, Roles.OnboardingCoordinator];
export const PROVIDER_SSN_REVEAL_PASSWORD_MIN_LENGTH = 8;

export const PROMOTE_ROLE_OPTIONS: ISelectOption[] = [
  { value: Roles.AssistantAssessor, label: 'Assistant Assessor' },
  { value: Roles.Biller, label: 'Biller' },
  { value: Roles.Prbt, label: 'BT' },
  { value: Roles.Bcba, label: 'BCBA' },
  { value: Roles.ClientSuccessManager, label: 'Client Success Manager' },
  { value: Roles.Guardian, label: 'Guardian' },
  { value: Roles.InvoiceCoordinator, label: 'Invoice Coordinator' },
  { value: Roles.OnboardingCoordinator, label: 'Onboarding Coordinator' },
  { value: Roles.QaSpecialist, label: 'QA Specialist' },
  { value: Roles.Vbt, label: 'VBT' },
];
